import React, { Component } from 'react';
import styled from '@emotion/styled';

import Field from 'redux-form/lib/Field';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Alert from 'react-bootstrap/lib/Alert';
import { Link } from 'react-router-dom';
import OutboundLink from '../OutboundLink';
import FacebookIcon from '../FacebookIcon';
import GoogleIcon from '../GoogleIcon';
import TwitterIcon from '../TwitterIcon';
import { FieldInputWithRedux } from '../FieldInput';

import styles from './styles.sass';
import { ButtonWithHoverAndPress } from '../../shared/Button';

const FieldWrapper = styled.div`
  margin-bottom: 14px;
`;

const ButtonWrapper = styled.div`
  margin: auto;
  margin-bottom: 14px;
  margin-top: 32px;
  max-width: 300px;
  width: 100%;
`;

const ErrorAlert = styled.div`
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: rgba(208, 2, 27, 0.1);
  font-size: 1.2rem;
  color: #e54751;
  margin: 12px 0;
`;

class Login extends Component {
  handleClickRequestResetPassword = evt => {
    const { clickRequestResetPassword } = this.props;
    evt.preventDefault();
    clickRequestResetPassword();
  };

  render() {
    const {
      error,
      handleSubmit,
      submitting,
      showHelpLinks,
      showSocialLogin,
      feedUrl,
    } = this.props;
    const feedUrlQuery = feedUrl
      ? `?feedUrl=${encodeURIComponent(feedUrl)}`
      : '';
    const signupUrl = `/signup${feedUrlQuery}`;
    const authTwitterUrl = `/auth/twitter${feedUrlQuery}`;
    const authFacebookUrl = `/login/facebook${feedUrlQuery}`;
    const authGoogleUrl = `/login/google${feedUrlQuery}`;
    // TODO: better handle errors
    let errorString = '';
    if (error) {
      try {
        const errorObj = JSON.parse(error);
        if (errorObj.status === 401) {
          errorString = 'Invalid username or password.';
        } else {
          errorString = 'Unable to log in at this time.';
        }
      } catch (err) {
        errorString = error;
      }
    }
    return (
      <div className={styles.loginForm}>
        <form onSubmit={handleSubmit} id="LoginForm">
          <FieldWrapper>
            <Field
              name="email"
              placeholder="Email"
              component={FieldInputWithRedux}
              type="email"
            />
          </FieldWrapper>
          <FieldWrapper>
            <Field
              name="password"
              placeholder="Password"
              component={FieldInputWithRedux}
              type="password"
            />
          </FieldWrapper>
          {errorString && <ErrorAlert>{errorString}</ErrorAlert>}
          <ButtonWrapper>
            <ButtonWithHoverAndPress
              text="Log in"
              disabled={submitting}
              shape="pill"
              type="unelevated"
              colorTheme="primary"
              size="sm"
              isFullWidth
              typeAttribute="submit"
              isEventBubblingAllowed
            />
          </ButtonWrapper>
        </form>
        {showSocialLogin && (
          <Row>
            <Col sm={4} className={styles.socialLogin}>
              <OutboundLink to={authFacebookUrl} style={{ color: '#39579B' }}>
                <FacebookIcon width={24} height={24} /> Facebook
              </OutboundLink>
            </Col>
            <Col sm={4} className={styles.socialLogin}>
              <OutboundLink to={authGoogleUrl} style={{ color: '#8c8c8c' }}>
                <GoogleIcon width={18} height={18} /> Google
              </OutboundLink>
            </Col>
            <Col sm={4} className={styles.socialLogin}>
              <OutboundLink to={authTwitterUrl} style={{ color: '#50ABF1' }}>
                <TwitterIcon width={25} height={20} /> Twitter
              </OutboundLink>
            </Col>
          </Row>
        )}
        {showHelpLinks && (
          <Row>
            <Col sm={12} className={styles.loginFooter}>
              <p style={{ marginBottom: '12px' }}>
                Don't have an account? <Link to={signupUrl}>Sign up</Link>{' '}
                instead.
              </p>
              <p className="text-center">
                <a onClick={this.handleClickRequestResetPassword}>
                  Forgot password?
                </a>
              </p>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

Login.defaultProps = {
  showHelpLinks: true,
  showSocialLogin: true,
};

export default Login;
